module.exports = __webpack_public_path__ + "img/none.c0a9f8a9.svg";